import { render, staticRenderFns } from "./CardInsurance.vue?vue&type=template&id=e223fc7c&"
import script from "./CardInsurance.vue?vue&type=script&lang=js&"
export * from "./CardInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports